import { Box, Typography } from "@mui/material";
import React from "react";
import NoDataIcon from "../../../assets/no_data.svg";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

type AuradineDataNotFoundStateProps = {
  message: string;
  fontSize?: string;
};

const AuradineDataNotFoundState: React.FC<
  AuradineDataNotFoundStateProps
> = (
  props: AuradineDataNotFoundStateProps
): React.ReactElement => {
  const { message } = props;
  const { colors } = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent={"center"}
      alignItems={"center"}
      alignContent={"center"}
      gap={4}
      height={"100%"}
    >
      <img
        style={{
          width: "auto",
          height: "auto",
          maxHeight: "20rem",
        }}
        src={NoDataIcon}
        alt="empty basket"
      />
      <Typography
        style={{
          fontSize: props.fontSize
            ? props.fontSize
            : "1.375rem",
          fontWeight: 400,
          color: colors?.text?.muted,     
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default AuradineDataNotFoundState;
